export default __webpack_public_path__ + "static/media/viber.61dd0730.png";